import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, msg } from './hubApi';

const d = iso => iso ? new Date(iso).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Australia/Sydney' }) : '';

export default function Receipt() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => { api('/billing/receipts/' + id).then(setR).catch(e => setErr(msg(e))); }, [id]);
  if (!r) return <p>{err || 'Loading…'}</p>;
  return (
    <section className="card receipt">
      <div className="row between"><h1>{r.seller.gstRegistered ? 'Tax invoice' : 'Receipt'}</h1><button className="ghost sm noprint" onClick={() => window.print()}>Print / save PDF</button></div>
      <p><b>{r.seller.name}</b>{r.seller.abn ? <> · ABN {r.seller.abn}</> : null}<br />support@betbuilder.com.au</p>
      <p>Receipt no. <b>{r.number}</b><br />Date: {d(r.date)}<br />Billed to: {r.buyer.name} ({r.buyer.email})</p>
      <table><tbody>
        <tr><td>{r.item}{r.period ? <><br /><span className="fine">Access {d(r.period.from)} – {d(r.period.to)}</span></> : null}</td><td className="r">A${r.amount.toFixed(2)}</td></tr>
        <tr><td><b>Total paid (AUD)</b></td><td className="r"><b>A${r.amount.toFixed(2)}</b></td></tr>
      </tbody></table>
      <p className="fine">{r.gstNote}<br />Paid by PayPal (ref {r.paypalId}).</p>
    </section>
  );
}
